/**
 * Created by jax.luo on 2016/8/23.
 */
angular.module('dpw.components')
    .directive('dpwThreeLegLogin', ['api', function (api) {
        return {
            scope: {
                ssoEntryPoint: '@'
            },
            restrict: 'A',
            transclude: true,
            templateUrl: 'dpw-three-leg-login.html',
            bindToController: true,
            controllerAs: 'threeLegCtrl',
            controller: [function () {
                this.login = function () {
                    var self = this;

                    api.call(api.threeLeg.getLoginUrl({
                        entryPoint: self.ssoEntryPoint
                    }), function (data) {
                        window.location = _.get(data, 'oAuthUrl');
                    });
                };
            }]
        };
    }]);